import { HttpErrorResponse } from '@angular/common/http';
import { Product } from '@ridango/core';

export enum BookRidePriorityType {
    PICKUP = 'DEPARTURE',
    DROPOFF = 'ARRIVAL',
}

export enum BookRidePaymentMethodType {
    ONE_TIME_PAYMENT = 'oneTimePayment',
    INVOICE = 'invoice',
}

export enum BookRideStatus {
    OPEN = 'open',
    PENDING = 'pending',
    COMPLETE = 'complete',
}
export interface BookRideStops {
    address: string;
    latitude: number;
    longitude: number;
    arrival_time?: string;
    arrival_timestamp?: string;
    departure_timestamp?: string;
}

export interface BookRideSpecification {
    companion: number;
    additionalInformation: string;
    isInvoice: boolean;
    productId?: string;
}

export interface BookRidePlan {
    dateAndTime: Date;
    priority: BookRidePriorityType;
    pickupFeature: GeocodeAddress;
    dropoffFeature: GeocodeAddress;
    stopovers: GeocodeAddress[];
}

export interface RidePlannerState {
    plan: BookRidePlan;
    specification: BookRideSpecification;
    bookingId: number;
    bookingStatus: BookRideStatus;
    estimatedPrice: number;
    products: Product[];
    step: number;
    error: HttpErrorResponse;
    loading?: boolean;
    isReturn?: boolean;
    potentialStops: StopData[];
    filteredStops: StopData[];
}

export interface ReturnWithPlan {
    plan: BookRidePlan;
    isReturn: boolean;
}

export interface StopData {
    address: string;
    id: number;
    latitude: number;
    longitude: number;
    stop_code: string;
    stop_name: string;
    direction?: string;
}

export enum GeocodeAddressType {
    BUS_STOP = 'BusStop',
}

export interface GeocodeAddress {
    id?: number | string;
    address: string;
    type?: string;
    lat: number;
    lon: number;
    geometry?: number[];
    direction?: string;
    latlng?: {
        lat: number;
        lng: number;
    };
}

export interface GeocodeStop {
    id: number;
    created_at: Date;
    updated_at: Date;
    stop_code: string;
    stop_name: string;
    stop_desc: string;
    stop_lat: number;
    stop_lon: number;
    zone_id: number;
    package_version: number;
    stop_area_id: string;
    arrival_bearing: number;
    departure_bearing: number;
    stop_municipality: {
        id: number;
        created_at: Date;
        updated_at: Date;
        external_id: number;
        stop_code: string;
        municipality: string;
    };
}

export interface GeocodeResponse {
    data: GeocodeAddress[];
    stops: GeocodeStop[];
}

export interface Feature {
    type: string;
    properties: {
        lon: number;
        lat: number;
        name: string;
        formatted: string;
        address_line1: string;
        district: string;
        municipality: string;
        city: string;
        postcode: string;
        county: string;
        geometry?: FeatureGeometry;
        place_id?: string;
    };
    bbox: number[];
}

export interface FeatureCollection {
    type: string;
    features: Feature[];
    query: string;
}

export interface FeatureGeometry {
    coordinates: number[];
    type: string;
}
